import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addFeedSuccess,
  addFeedFailure,
  //
  deleteFeedSuccess,
  deleteFeedFailure,
  //
  editFeedSuccess,
  editFeedFailure,
  //
  fetchFeeds as fetchFeedAction,
  fetchFeedsSuccess,
  fetchFeedsFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_FEED,
  DELETE_FEED,
  EDIT_FEED,
  FETCH_FEEDS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchFeedsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { feeds } = yield select((state) => state?.FeedReducer);
  let query = payload ? QueryString.stringify(payload) : "";
  let updatesResponse = { ...feeds };

  try {
    const { data } = yield call(api(token).get, `/api/feed?${query}`);

    if (payload?.page <= 1) {
      updatesResponse = data;
    } else {
      updatesResponse = {
        ...data,
        data: updatesResponse.data.concat(data?.data),
      };
    }
    yield put(fetchFeedsSuccess(updatesResponse));
  } catch (e) {
    yield put(fetchFeedsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching team list!"));
  }
}

export function* getViewDataSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/feed/${payload}`);
    yield put(getViewDataSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching feed data!"));
  }
}

export function* addFeedSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/feed/add`, payload);
    if (data) {
      yield put(successAlert("Feed created successfully!"));
      yield put(addFeedSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(addFeedFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editFeedSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/feed/edit/${payload.id}`,
      payload?.data
    );
    if (data) {
      yield put(successAlert("Feed updated successfully!"));
      yield put(editFeedSuccess());
      yield put(getViewDataAction(payload.id));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(editFeedFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteFeedSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/feed/${payload}`);
    if (data) {
      yield put(successAlert("Feed deleted successfully!"));
      yield put(deleteFeedSuccess());
      typeof onDelete === "function" && onDelete(payload);
    }
  } catch (e) {
    yield put(deleteFeedFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchFeedsFlow() {
  yield takeEvery(FETCH_FEEDS, fetchFeedsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addFeedFlow() {
  yield takeEvery(ADD_FEED, addFeedSaga);
}
export function* editFeedFlow() {
  yield takeEvery(EDIT_FEED, editFeedSaga);
}
export function* deleteFeedFlow() {
  yield takeEvery(DELETE_FEED, deleteFeedSaga);
}

export default function* FeedSaga() {
  yield all([
    fetchFeedsFlow(),
    addFeedFlow(),
    editFeedFlow(),
    deleteFeedFlow(),
    getViewDataFlow(),
  ]);
}
